// Web: No StripeProvider needed — we use Stripe Checkout redirect
export default function StripeWrapper({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
